"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiTransactionFindBaseQueryDto = void 0;
const pagination_dto_1 = require("../../../../shared/types/dtos/pagination.dto");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const transform_bool_1 = require("../../../../shared/pipes/transform-bool");
let BillingApiTransactionFindBaseQueryDto = class BillingApiTransactionFindBaseQueryDto extends pagination_dto_1.PaginationDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Подключить в выдачу информацию о счёте",
  type: Boolean,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), (0, transform_bool_1.TransformBool)(), __metadata("design:type", Object)], BillingApiTransactionFindBaseQueryDto.prototype, "joinAccount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Подключить в выдачу информацию об операции",
  type: Boolean,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), (0, transform_bool_1.TransformBool)(), __metadata("design:type", Object)], BillingApiTransactionFindBaseQueryDto.prototype, "joinOperation", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Подключить в выдачу информацию обо всех транзакциях в операции",
  type: Boolean,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), (0, transform_bool_1.TransformBool)(), __metadata("design:type", Object)], BillingApiTransactionFindBaseQueryDto.prototype, "joinOperationTransaction", void 0);
BillingApiTransactionFindBaseQueryDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiTransactionFindBaseQueryDto);
exports.BillingApiTransactionFindBaseQueryDto = BillingApiTransactionFindBaseQueryDto;
